__turbopack_context__.v({
  "bigDesktopPageWidth": "categoryButtons-module-scss-module__jLcPXW__bigDesktopPageWidth",
  "categoryButton": "categoryButtons-module-scss-module__jLcPXW__categoryButton",
  "categoryButtonList": "categoryButtons-module-scss-module__jLcPXW__categoryButtonList",
  "desktopPageWidth": "categoryButtons-module-scss-module__jLcPXW__desktopPageWidth",
  "root": "categoryButtons-module-scss-module__jLcPXW__root",
  "sanitized": "categoryButtons-module-scss-module__jLcPXW__sanitized",
  "threeLineEllipse": "categoryButtons-module-scss-module__jLcPXW__threeLineEllipse",
});
